export const esES = {
  lang: 'es-ES',
  country: 'ES',
  flag: '🇪🇸',
  currency: '€',

  app: {
    sidebar: {
      dashboard: 'Panel',
      transactions: 'Transacciones',
      pots: 'Botes',
      receipts: 'Recibos',
      reports: 'Informes',
      categories: 'Categorias',
      tags: 'Etiquetas',
      budgets: 'Presupuesto',
      recurring: 'Recurrentes',
      settings: 'Ajustes',
      darkMode: 'Modo Oscuro',
      lightMode: 'Modo Claro',
      logout: 'Cerrar sesion',
    },
    common: {
      loading: 'Cargando...',
      save: 'Guardar',
      cancel: 'Cancelar',
      confirmTitle: 'Confirmar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      search: 'Buscar',
      filter: 'Filtros',
      export: 'Exportar',
      type: 'Tipo',
      category: 'Categoria',
      date: 'Fecha',
      amount: 'Importe',
      description: 'Descripcion',
      actions: 'Acciones',
      income: 'Ingreso',
      expense: 'Gasto',
      name: 'Nombre',
      color: 'Color',
      confirmDelete: 'Estas seguro de que quieres eliminar?',
      noResults: 'No se encontraron resultados',
      status: 'Estado',
      error: 'Error',
      success: 'Exito',
      page: 'Pagina',
      of: 'de',
      showing: 'Mostrando',
      viewDetails: 'Ver detalles',
      tags: 'Etiquetas',
      receipt: 'Recibo',
      receiptAttached: 'Recibo adjunto',
    },
    categoryLabels: {
      food: 'Alimentación',
      transport: 'Transporte',
      shopping: 'Compras',
      entertainment: 'Entretenimiento',
      health: 'Salud',
      education: 'Educación',
      utilities: 'Servicios',
      housing: 'Vivienda',
      travel: 'Viajes',
      other: 'Otros',
      salary: 'Salario',
      investment: 'Inversión',
      freelance: 'Freelance',
      gift: 'Regalo',
    },
    tags: {
      loading: 'Cargando etiquetas...',
      error: 'No se pudieron cargar tus etiquetas. Intentalo de nuevo.',
      title: 'Etiquetas',
      subtitle: 'Crea etiquetas para organizar y filtrar tus transacciones',
      newTag: 'Nueva Etiqueta',
      noTags: 'Ninguna etiqueta creada',
      noTagsDescription: 'Las etiquetas se crean automaticamente cuando usas #etiqueta en tus mensajes, o puedes crearlas manualmente aqui.',
      createFirst: 'Crear primera etiqueta',
      howToUse: 'Como usar etiquetas',
      howToUseDescription: 'Anade etiquetas a tus transacciones via WhatsApp usando #etiqueta. Por ejemplo: "Almuerzo 35 euros #trabajo #comida". Las etiquetas ayudan a filtrar y analizar tus gastos.',
      form: {
        name: 'Nombre de la etiqueta',
        namePlaceholder: 'trabajo, viaje, almuerzo...',
        nameHint: 'Se convertira a minusculas sin espacios',
        color: 'Color',
      },
      stats: {
        title: 'Estadisticas',
        created: 'Etiquetas creadas',
        totalUsage: 'Total de usos',
        mostUsed: 'Mas usada',
        unused: 'Sin uso',
      },
      confirmDelete: 'Eliminar Etiqueta',
      deleteWarning: 'Estas seguro de que quieres eliminar la etiqueta',
      deleteUsageWarning: 'Esta etiqueta se esta usando en {count} transacciones. La etiqueta sera eliminada de esas transacciones.',
    },
    pots: {
      title: 'Botes',
      subtitle: 'Organiza tu dinero en diferentes botes por moneda',
      loading: 'Cargando botes...',
      error: 'No se pudieron cargar tus botes. Intentalo de nuevo.',
      errorTitle: 'Error al cargar botes',
      newPot: 'Nuevo Bote',
      editPot: 'Editar Bote',
      noPots: 'Ningun bote creado',
      noPotsDescription: 'Crea botes para organizar tu dinero por moneda u objetivo.',
      createFirst: 'Crear primer bote',
      setDefault: 'Establecer como predeterminado',
      transactions: 'transacciones',
      confirmDelete: 'Eliminar Bote',
      confirmDeleteMessage: 'Estas seguro de que quieres eliminar el bote',
      deleteWarning: 'Este bote tiene {count} transacciones que seran movidas al bote predeterminado.',
      form: {
        name: 'Nombre',
        namePlaceholder: 'Ej: Fondo de emergencia',
        description: 'Descripcion (opcional)',
        descriptionPlaceholder: 'Para que sirve este bote?',
        currency: 'Moneda',
        color: 'Color',
      },
    },
    transactions: {
      loading: 'Cargando transacciones...',
      title: 'Transacciones',
      subtitle: 'Gestiona tus ingresos y gastos',
      searchPlaceholder: 'Buscar por descripcion, comercio...',
      showing: 'Mostrando {count} de {total} transacciones',
      confirmDelete: 'Estas seguro de que quieres eliminar esta transaccion?',
      filters: {
        filters: 'Filtros',
        dateStart: 'Fecha Inicio',
        dateEnd: 'Fecha Fin',
        startDate: 'Fecha Inicio',
        endDate: 'Fecha Fin',
        minAmount: 'Importe Minimo',
        maxAmount: 'Importe Maximo',
      },
      table: {
        description: 'Descripcion',
        category: 'Categoria',
        date: 'Fecha',
        amount: 'Importe',
        receipt: 'Recibo',
        actions: 'Acciones',
      },
      viewReceipt: 'Ver recibo',
      modal: {
        editTitle: 'Editar Transaccion',
        detailsTitle: 'Detalles de la Transaccion',
        merchant: 'Comercio',
        description: 'Descripcion',
        tags: 'Etiquetas',
        receipt: 'Recibo',
        receiptAttached: 'Recibo adjunto',
        createCategory: 'Crear nueva categoria',
      },
    },
    dashboard: {
      title: 'Panel',
      subtitle: 'Vision general de tus finanzas',
      period: {
        week: 'Semana',
        month: 'Mes',
        year: 'Ano',
      },
      cards: {
        income: 'Ingresos',
        expense: 'Gastos',
        expenses: 'Gastos',
        balance: 'Saldo',
        transactions: 'Transacciones',
      },
      charts: {
        spending: 'Gastos por Categoria',
        trend: 'Tendencia',
        byCategory: 'Gastos por Categoria',
      },
      recent: 'Transacciones Recientes',
      viewAll: 'Ver todas',
      topCategories: 'Categorias Principales',
      items: 'elementos',
      loading: 'Cargando panel...',
    },
    settings: {
      title: 'Ajustes',
      subtitle: 'Gestiona tu perfil y preferencias',
      profile: {
        title: 'Perfil',
        phone: 'Telefono',
        phoneVerified: 'Verificado',
        phoneHint: 'El telefono se usa para autenticacion y no se puede cambiar aqui.',
        name: 'Nombre',
        namePlaceholder: 'Tu nombre',
        email: 'Email',
        emailPlaceholder: 'tu@email.com',
        emailHint: 'Usado para recibir informes y notificaciones.',
        verified: 'Verificado',
      },
      preferences: {
        title: 'Preferencias',
        language: 'Idioma',
        languageHint: 'Idioma usado en los mensajes de WhatsApp e informes.',
        timezone: 'Zona Horaria',
      },
      subscription: {
        title: 'Suscripcion',
        plan: 'Plan',
        status: {
          active: 'Activo',
          trialing: 'Prueba',
          pastDue: 'Pago Pendiente',
          past_due: 'Pago Pendiente',
          canceled: 'Cancelado',
          expired: 'Expirado',
        },
        trialEnds: 'La prueba termina en',
        trialEndsAt: 'La prueba termina en',
        nextBilling: 'Proximo cobro',
        upgrade: 'Mejorar Plan',
        support: 'Contactar Soporte',
        contactSupport: 'Contactar Soporte',
        cancel: 'Cancelar suscripcion',
        noSubscription: 'Sin suscripcion activa',
        noSubscriptionDesc: 'Suscribete a un plan para desbloquear todas las funcionalidades.',
        viewPlans: 'Ver Planes',
        plans: {
          free: 'Gratuito',
          basic: 'Basico',
          starter: 'Inicial',
          pro: 'Pro',
          professional: 'Profesional',
          enterprise: 'Empresa',
          vip: 'VIP',
        },
      },
      account: {
        title: 'Informacion de la Cuenta',
        id: 'ID de la cuenta',
        createdAt: 'Cuenta creada el',
      },
      saveChanges: 'Guardar Cambios',
      loading: 'Cargando ajustes...',
      error: 'Error al cargar ajustes',
      errorDesc: 'No se pudo cargar tu informacion. Intentalo de nuevo.',
    },
    budgets: {
      title: 'Presupuestos',
      subtitle: 'Define limites de gastos por categoria',
      loading: 'Cargando presupuestos...',
      error: 'Error al cargar presupuestos',
      errorDesc: 'No se pudieron cargar tus presupuestos. Intentalo de nuevo.',
      newBudget: 'Nuevo Presupuesto',
      noBudgets: 'Sin presupuestos definidos',
      noBudgetsDesc: 'Crea presupuestos para controlar tus gastos por categoria y recibir alertas al acercarte al limite.',
      createFirst: 'Crear primer presupuesto',
      period: {
        monthly: 'Mensual',
        yearly: 'Anual',
      },
      status: {
        safe: 'Dentro del presupuesto',
        warning: 'Cerca del limite',
        danger: 'Limite excedido!',
      },
      spent: 'gastado',
      limit: 'Limite',
      remaining: 'Restante',
      exceeded: 'Excedido',
      summary: {
        totalBudgeted: 'Total Presupuestado',
        totalSpent: 'Total Gastado',
        overBudget: 'Sobre el Limite',
        budget: 'presupuesto',
        budgets: 'presupuestos',
      },
      tips: {
        title: 'Consejos para un buen presupuesto',
        tip1: 'Empieza con categorias donde gastas mas',
        tip2: 'Define limites realistas basados en tu historial',
        tip3: 'Usa la alerta del 80% para actuar antes de exceder',
        tip4: 'Revisa tus presupuestos mensualmente',
      },
      confirmDelete: 'Eliminar Presupuesto',
      confirmDeleteMsg: 'Estas seguro de eliminar el presupuesto',
      form: {
        newBudget: 'Nuevo Presupuesto',
        editBudget: 'Editar Presupuesto',
        budgetName: 'Nombre del presupuesto',
        budgetNamePlaceholder: 'Ej: Alimentación mensual, Transporte...',
        category: 'Categoría (opcional)',
        allExpenses: 'Todos los gastos',
        limit: 'Límite',
        period: 'Período',
        alertThreshold: 'Alertar al alcanzar',
        alertDescription: 'Serás notificado cuando tus gastos alcancen este porcentaje del límite.',
        preview: 'Vista previa',
        save: 'Guardar',
        create: 'Crear',
      },
    },
    categories: {
      title: 'Categorias',
      subtitle: 'Gestiona tus categorias de ingresos y gastos',
      loading: 'Cargando categorias...',
      error: 'Error al cargar categorias',
      errorDesc: 'No se pudieron cargar tus categorias. Intentalo de nuevo.',
      newCategory: 'Nueva Categoria',
      myCategories: 'Mis Categorias',
      systemCategories: 'Categorias del Sistema',
      systemCategoriesDesc: 'Estas categorias son predeterminadas y no se pueden editar.',
      noCustomCategories: 'Sin categorias personalizadas',
      noCustomCategoriesDesc: 'Crea categorias personalizadas para organizar mejor tus finanzas.',
      createFirst: 'Crear primera categoria',
      type: {
        income: 'Ingreso',
        expense: 'Gasto',
      },
      deductible: 'Deducible',
      confirmDelete: 'Eliminar Categoria',
      confirmDeleteMsg: 'Estas seguro de eliminar la categoria',
      deleteWarning: 'Las transacciones existentes se moveran a "Otros".',
      form: {
        newCategory: 'Nueva Categoria',
        editCategory: 'Editar Categoria',
        categoryName: 'Nombre de la categoria',
        categoryNamePlaceholder: 'Ej: Alimentacion, Transporte...',
        type: 'Tipo',
        icon: 'Icono',
        colour: 'Color',
        preview: 'Vista previa',
        taxDeductible: 'Deducible de impuestos',
        save: 'Guardar',
        create: 'Crear',
      },
    },
    receipts: {
      title: 'Recibos',
      subtitle: 'Visualiza y gestiona tus comprobantes fiscales',
      loading: 'Cargando recibos...',
      error: 'Error al cargar recibos',
      errorDesc: 'No se pudieron cargar tus recibos. Intentalo de nuevo.',
      status: {
        all: 'Todos los Estados',
        processing: 'Procesando',
        completed: 'Completados',
        failed: 'Fallido',
        manual_review: 'Revision Manual',
      },
      year: {
        all: 'Todos los Anios',
      },
      stats: {
        total: 'Total',
        completed: 'Completados',
        processing: 'Procesando',
        failed: 'Fallido',
      },
      noReceipts: 'Sin recibos aun',
      noReceiptsFiltered: 'No se encontraron recibos',
      noReceiptsDesc: 'Envia una foto de recibo por WhatsApp para empezar',
      noReceiptsFilteredDesc: 'Ajusta los filtros para ver mas recibos',
      showing: 'Mostrando {count} de {total} recibos',
      page: 'Pagina {current} de {total}',
    },
    recurring: {
      title: 'Transacciones Recurrentes',
      subtitle: 'Automatiza tus gastos e ingresos fijos',
      loading: 'Cargando transacciones recurrentes...',
      error: 'Error al cargar transacciones recurrentes',
      errorDesc: 'No se pudieron cargar tus transacciones recurrentes. Intentalo de nuevo.',
      newRecurring: 'Nueva Recurrente',
      noRecurring: 'Sin transacciones recurrentes',
      noRecurringDesc: 'Configura transacciones que se repiten automaticamente, como alquiler, suscripciones o salario.',
      createFirst: 'Crear primera recurrente',
      active: 'Activa',
      paused: 'Pausada',
      activeCount: 'Activas ({count})',
      pausedCount: 'Pausadas ({count})',
      next: 'Proxima',
      summary: {
        monthlyExpenses: 'Gastos Mensuales',
        monthlyIncome: 'Ingresos Mensuales',
        netMonthly: 'Saldo Mensual',
      },
      frequency: {
        daily: 'Diaria',
        weekly: 'Semanal',
        monthly: 'Mensual',
        yearly: 'Anual',
      },
      dayOf: {
        everyDay: 'Cada dia',
        every: 'Cada',
        dayOfMonth: 'Dia {day}',
        annually: 'Anualmente',
      },
      actions: {
        pause: 'Pausar',
        activate: 'Activar',
        processNow: 'Procesar ahora',
      },
      tips: {
        title: 'Sobre Transacciones Recurrentes',
        tip1: 'Las transacciones se crean automaticamente en la fecha programada',
        tip2: 'Puedes pausar temporalmente sin eliminar',
        tip3: 'Usa para gastos fijos como alquiler, luz, internet',
        tip4: 'Tambien funciona para ingresos como salario',
      },
      confirmDelete: 'Eliminar Transaccion Recurrente',
      confirmDeleteMsg: 'Estas seguro de eliminar la transaccion recurrente',
      deleteWarning: 'Las transacciones ya creadas no seran afectadas.',
      form: {
        newRecurring: 'Nueva Transacción Recurrente',
        editRecurring: 'Editar Transacción Recurrente',
        description: 'Descripción',
        descriptionPlaceholder: 'Ej: Alquiler, Netflix, Salario...',
        amount: 'Monto',
        category: 'Categoría',
        selectCategory: 'Selecciona una categoría',
        selectPot: 'Selecciona un bote (opcional)',
        frequencyLabel: 'Frecuencia',
        dayOfMonth: 'Día del mes',
        dayOfWeek: 'Día de la semana',
        day: 'Día',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha de fin (opcional)',
        preview: 'Vista previa',
        save: 'Guardar',
        create: 'Crear',
        daysOfWeek: {
          monday: 'Lunes',
          tuesday: 'Martes',
          wednesday: 'Miércoles',
          thursday: 'Jueves',
          friday: 'Viernes',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
      },
    },
    reports: {
      title: 'Informes Fiscales',
      subtitle: 'Resumenes anuales para declaracion de impuestos',
      loading: 'Cargando informes...',
      error: 'Error al cargar informes',
      errorDesc: 'No se pudieron cargar tus informes. Intentalo de nuevo.',
      year: {
        all: 'Todos los anios',
      },
      noReports: 'Sin informes aun',
      noReportsFiltered: 'No se encontraron informes',
      noReportsDesc: 'Tus informes fiscales apareceran aqui al final de cada anio.',
      noReportsFilteredDesc: 'No hay informes para el anio {year}.',
      generatedOn: 'Generado el',
      card: {
        income: 'Ingresos',
        expenses: 'Gastos',
        deductible: 'Deducibles',
        balance: 'Saldo',
      },
      country: {
        BR: 'Brasil',
        GB: 'Reino Unido',
      },
      tips: {
        title: 'Sobre los Informes Fiscales',
        desc: 'Los informes se generan automaticamente al final de cada anio fiscal.',
        tip1: 'Brasil: Anio fiscal de enero a diciembre',
        tip2: 'Reino Unido: Anio fiscal de abril a marzo',
      },
    },
  },

  nav: {
    pricing: 'Precios',
    features: 'Funcionalidades',
    howItWorks: 'Como Funciona',
    login: 'Iniciar Sesion',
  },

  hero: {
    badge: 'Control financiero sin complicaciones',
    title: 'Organiza tus finanzas por WhatsApp',
    subtitle: 'Envia un mensaje, foto o audio. La IA registra, categoriza y organiza todo por ti.',
    cta: 'Empezar Gratis',
    ctaSubtext: '14 dias gratis, sin tarjeta',
    ukOnly: 'Disponible solo para numeros del Reino Unido por el momento',
    trustedBy: 'Tan sencillo como enviar un mensaje',
  },

  howItWorks: {
    title: 'Como Funciona',
    subtitle: 'Tres formas de registrar. Cero esfuerzo.',
    step1: {
      icon: '💬',
      title: 'Texto',
      description: 'Escribe de forma natural: "50 almuerzo", "+500 nomina", "uber ayer era trabajo"',
      example: '"85 supermercado"',
    },
    step2: {
      icon: '📸',
      title: 'Foto',
      description: 'Envia foto del recibo. El OCR extrae importe, tienda, NIF y articulos automaticamente.',
      example: 'Foto del ticket',
    },
    step3: {
      icon: '🎤',
      title: 'Audio',
      description: 'Graba un audio describiendo el gasto. Lo transcribimos y registramos.',
      example: '"Gaste 200 en la gasolinera"',
    },
  },

  features: {
    title: 'Mucho mas que un registro de gastos',
    subtitle: 'Herramientas potentes, interfaz sencilla',
    list: [
      {
        icon: 'wallet',
        title: 'Botes (Carteras)',
        description: 'Organiza por cuenta: Santander, BBVA, Proyecto X. Cada bote con su moneda.',
        command: '"crear bote Santander"',
      },
      {
        icon: 'target',
        title: 'Presupuestos',
        description: 'Define limites por categoria. Alerta cuando alcances el 80%.',
        command: '"presupuesto 500 alimentacion"',
      },
      {
        icon: 'hash',
        title: 'Etiquetas',
        description: 'Usa #hashtags para organizar: "50 uber #cliente #proyecto-x"',
        command: '"mis gastos #trabajo"',
      },
      {
        icon: 'repeat',
        title: 'Recurrentes',
        description: 'Configura gastos fijos. Alquiler, Netflix, nomina - registrado automatico.',
        command: '"crear recurrente 1500 alquiler"',
      },
      {
        icon: 'globe',
        title: 'Multi-moneda',
        description: 'EUR, USD, GBP, BRL. Tipos de cambio actualizados. Panel consolidado.',
        command: '"50 usd almuerzo bote Viaje"',
      },
      {
        icon: 'layout',
        title: 'Panel Web',
        description: 'Graficos, filtros, exportacion. Todo lo que registras, visible en el portal.',
        command: 'keepnota.com',
      },
    ],
  },

  commands: {
    title: 'Comandos Rapidos',
    subtitle: 'Conversacion natural. Sin memorizar nada.',
    list: [
      { cmd: '50 cafe', desc: 'Registra gasto de 50EUR' },
      { cmd: '+2000 freelance', desc: 'Registra ingreso' },
      { cmd: 'resumen', desc: 'Muestra resumen del mes' },
      { cmd: 'mis botes', desc: 'Lista tus carteras' },
      { cmd: 'borrar ultimo', desc: 'Elimina ultima transaccion' },
      { cmd: 'ayuda', desc: 'Lista todos los comandos' },
    ],
  },

  audience: {
    title: 'Hecho para quien busca simplicidad',
    subtitle: 'Si usas WhatsApp, ya sabes usar KeepNota',
    personas: [
      {
        icon: 'briefcase',
        title: 'Autonomos y Freelancers',
        description: 'Separa personal de trabajo. Sabe exactamente cuanto entra y sale.',
      },
      {
        icon: 'user',
        title: 'Finanzas Personales',
        description: 'Basta de hojas de calculo. Registra gastos en el momento que ocurren.',
      },
      {
        icon: 'users',
        title: 'Parejas y Familias',
        description: 'Botes compartidos. Cada uno registra, todos lo siguen.',
      },
      {
        icon: 'plane',
        title: 'Viajeros',
        description: 'Multi-moneda automatico. Gastos en cualquier lugar, todo convertido.',
      },
    ],
  },

  comparison: {
    title: 'Por que KeepNota?',
    subtitle: 'Comparado con las alternativas',
    vsSpreadsheet: {
      title: 'vs Hoja de Calculo',
      points: [
        'Sin abrir el ordenador',
        'Registro instantaneo',
        'Categoriza solo',
        'Foto del recibo = todo completado',
      ],
    },
    vsApps: {
      title: 'vs Apps de Finanzas',
      points: [
        'Funciona en WhatsApp (ya lo usas cada dia)',
        'Cero friccion - solo envia mensaje',
        'OCR de recibos incluido',
        'Sin notificaciones molestas',
      ],
    },
    vsManual: {
      title: 'vs Anotar a Mano',
      points: [
        'Nunca te olvidas de registrar',
        'Audio cuando no puedes escribir',
        'Historial siempre accesible',
        'Informes automaticos',
      ],
    },
  },

  taxBonus: {
    title: 'Bonus: Preparado para la Declaracion',
    subtitle: 'Cuando llegue el momento, tus datos ya estaran organizados',
    points: [
      'Categorias mapeadas para deducciones fiscales',
      'NIF capturado automaticamente de los recibos',
      'Informe anual exportable',
      'Separa gastos deducibles con etiquetas',
    ],
  },

  pricing: {
    title: 'Planes',
    subtitle: 'Empieza gratis. Mejora cuando lo necesites.',
    monthly: '/mes',
    yearly: '/ano',
    savePercent: 'Ahorra 20%',
    basic: {
      name: 'Basico',
      price: '9,90',
      features: [
        '30 fotos de recibo/mes',
        '20 audios/mes',
        'Textos ilimitados',
        'Panel y graficos basicos',
        'Informe mensual',
        'Exportar CSV',
        'Retencion de recibos: 1 ano',
      ],
    },
    pro: {
      name: 'Pro',
      price: '19,90',
      popular: 'Mas Popular',
      features: [
        'Fotos y audios ilimitados',
        'Todo del Basico +',
        'Graficos y filtros avanzados',
        'Comparativa mes a mes',
        'Exportar PDF',
        'Informe anual (IRPF)',
        'Soporte prioritario',
        'Retencion de recibos: 2 anos',
      ],
    },
    cta: 'Empezar Gratis',
    trial: '14 dias gratis, cancela cuando quieras',
  },

  referral: {
    title: 'Invita y Gana',
    subtitle: 'Comparte con amigos y gana dias gratis',
    tiers: [
      { range: '1-5 invitaciones', reward: '7 dias gratis cada una' },
      { range: '6-15 invitaciones', reward: '10 dias gratis cada una' },
      { range: '16+ invitaciones', reward: '14 dias + creditos' },
    ],
    cta: 'Saber mas',
  },

  faq: {
    title: 'Preguntas Frecuentes',
    items: [
      {
        q: 'Necesito descargar alguna app?',
        a: 'No! Funciona 100% por WhatsApp. Solo guarda nuestro numero y empieza a enviar tus gastos. Tambien tenemos un portal web para ver graficos e informes.',
      },
      {
        q: 'Mis datos estan seguros?',
        a: 'Si! Usamos cifrado de extremo a extremo, servidores seguros y cumplimos con el RGPD. Puedes exportar o eliminar tus datos en cualquier momento.',
      },
      {
        q: 'Puedo cancelar cuando quiera?',
        a: 'Claro! Sin permanencia. Cancela en cualquier momento por el propio WhatsApp escribiendo "cancelar". Tus datos quedan disponibles 30 dias despues de la cancelacion.',
      },
      {
        q: 'Funciona para autonomos?',
        a: 'Perfecto para eso! Usa botes para separar cuenta personal de profesional, etiquetas para clientes, y ten control total de ingresos y gastos.',
      },
      {
        q: 'Como funciona el OCR de recibos?',
        a: 'Envia la foto del ticket o factura. Nuestra IA extrae automaticamente: importe total, nombre de la tienda, NIF, fecha e incluso los articulos. Solo verificar y listo.',
      },
      {
        q: 'Puedo usar en mas de una moneda?',
        a: 'Si! Soportamos Euro, Dolar, Libra y Real. Cada bote puede tener su moneda, y el panel muestra todo convertido a tu moneda principal.',
      },
    ],
  },

  cta: {
    title: 'Empieza a organizar tus finanzas hoy',
    subtitle: '14 dias gratis. Sin tarjeta. Cancela cuando quieras.',
    button: 'Hablar por WhatsApp',
    secondary: 'Ver demostracion',
  },

  footer: {
    copyright: '© 2025 KeepNota by Fig and Rosa Ltd. Todos los derechos reservados.',
    terms: 'Terminos de Uso',
    privacy: 'Privacidad',
    tagline: 'Control financiero via WhatsApp',
  },

  privacy: {
    title: 'Politica de Privacidad',
    lastUpdate: 'Ultima actualizacion: Diciembre de 2024',
    intro: 'KeepNota ("nosotros", "nuestro" o "Servicio") valora la privacidad de los usuarios. Esta Politica de Privacidad explica como recopilamos, usamos y protegemos tu informacion.',
    sections: [
      {
        title: '1. Datos que Recopilamos',
        content: `Recopilamos los siguientes datos cuando usas KeepNota:
• **Numero de telefono**: Para identificacion y comunicacion via WhatsApp
• **Mensajes enviados**: Textos, audios e imagenes de recibos que envias
• **Datos extraidos**: Importes, categorias e informacion de los recibos procesados
• **Datos de uso**: Horarios de acceso e interacciones con el servicio`,
      },
      {
        title: '2. Como Usamos tus Datos',
        content: `Utilizamos tus datos para:
• Procesar y organizar tus recibos
• Generar informes y graficos de gastos
• Identificar gastos deducibles en la Declaracion de la Renta
• Mejorar nuestros servicios y algoritmos de IA
• Enviar comunicaciones sobre tu cuenta y el servicio`,
      },
      {
        title: '3. Almacenamiento y Seguridad',
        content: `Tus datos se almacenan con seguridad:
• Cifrado en transito (HTTPS/TLS)
• Almacenamiento en servidores seguros
• Acceso restringido solo a sistemas automatizados
• Copias de seguridad regulares y redundancia de datos`,
      },
      {
        title: '4. Comparticion de Datos',
        content: `**No vendemos tus datos.** Solo compartimos con:
• **Proveedores de servicio**: Procesamiento de pagos (Stripe), almacenamiento (AWS)
• **IA/ML**: Google (Gemini) para procesamiento de imagenes y texto - datos anonimizados
• **Obligacion legal**: Cuando lo exija la ley o una orden judicial`,
      },
      {
        title: '5. Tus Derechos (RGPD)',
        content: `Tienes derecho a:
• **Acceso**: Solicitar copia de tus datos
• **Rectificacion**: Corregir datos incorrectos
• **Supresion**: Solicitar eliminacion de tus datos
• **Portabilidad**: Recibir tus datos en formato estructurado
• **Revocacion**: Cancelar el consentimiento en cualquier momento

Para ejercer tus derechos, envia mensaje a nuestro WhatsApp o email: privacidad@keepnota.com`,
      },
      {
        title: '6. Retencion de Datos',
        content: `Mantenemos tus datos mientras tu cuenta este activa. Tras la cancelacion:
• Datos financieros: Mantenidos durante 5 anos (obligacion fiscal)
• Imagenes de recibos: Eliminadas en 30 dias
• Datos de cuenta: Eliminados en 30 dias`,
      },
      {
        title: '7. Contacto',
        content: `Para dudas sobre privacidad:
• Email: privacidad@keepnota.com
• WhatsApp: Envia "PRIVACIDAD" a nuestro numero`,
      },
    ],
  },

  feedback: {
    title: 'Envia tu Feedback',
    subtitle: 'Tu opinion nos ayuda a mejorar KeepNota',
    typeLabel: 'Tipo de feedback',
    types: {
      general: 'General',
      feature_request: 'Sugerencia',
      bug: 'Bug/Error',
      complaint: 'Queja',
      praise: 'Elogio',
      account_deletion: 'Eliminar cuenta',
    },
    messageLabel: 'Tu mensaje',
    messagePlaceholder: 'Cuentanos lo que piensas...',
    ratingLabel: 'Valoracion (opcional)',
    nameLabel: 'Tu nombre (opcional)',
    namePlaceholder: 'Como podemos llamarte?',
    emailLabel: 'Email (opcional)',
    emailPlaceholder: 'tu@email.com',
    emailHint: 'Para responder a tu feedback',
    submit: 'Enviar Feedback',
    errors: {
      messageRequired: 'Por favor, escribe un mensaje',
      messageTooShort: 'Mensaje demasiado corto (minimo 10 caracteres)',
      submitFailed: 'Error al enviar. Intentalo de nuevo.',
    },
    success: {
      title: 'Feedback enviado!',
      message: 'Gracias por compartir tu opinion. Lo revisaremos con atencion.',
    },
    backToHome: 'Volver a la pagina principal',
  },

  terms: {
    title: 'Terminos de Uso',
    lastUpdate: 'Ultima actualizacion: Diciembre de 2024',
    intro: 'Al usar KeepNota, aceptas estos Terminos de Uso. Lee atentamente.',
    sections: [
      {
        title: '1. Sobre el Servicio',
        content: `KeepNota es un servicio de organizacion de recibos y gastos via WhatsApp. Ofrecemos:
• Procesamiento automatico de recibos por foto, audio o texto
• Categorizacion y organizacion de gastos
• Informes y graficos de gastos
• Identificacion de gastos deducibles en el IRPF

El servicio se proporciona "tal cual" y puede ser modificado en cualquier momento.`,
      },
      {
        title: '2. Registro y Cuenta',
        content: `Para usar KeepNota:
• Debes tener 18 anos o mas
• Proporcionar informacion veraz
• Mantener tu numero de telefono actualizado
• No compartir acceso con terceros

Eres responsable de todas las actividades en tu cuenta.`,
      },
      {
        title: '3. Uso Aceptable',
        content: `Aceptas NO:
• Usar el servicio para fines ilegales
• Enviar contenido ofensivo, difamatorio o ilegal
• Intentar acceder a sistemas o datos de otros usuarios
• Usar bots o automatizacion no autorizada
• Revender o redistribuir el servicio`,
      },
      {
        title: '4. Pagos y Suscripcion',
        content: `• Ofrecemos periodo de prueba gratuito de 14 dias
• Tras la prueba, la suscripcion se cobra mensualmente
• Pagos procesados via Stripe (tarjeta de credito)
• La cancelacion se puede hacer en cualquier momento
• No hay reembolso por periodos parciales`,
      },
      {
        title: '5. Propiedad Intelectual',
        content: `• KeepNota y sus componentes son propiedad de Figrosa
• Mantienes la propiedad de tus datos y recibos
• Te concedemos licencia limitada para usar el servicio
• Nos concedes licencia para procesar tus datos segun sea necesario`,
      },
      {
        title: '6. Limitacion de Responsabilidad',
        content: `• KeepNota no sustituye el asesoramiento contable o fiscal
• No garantizamos precision absoluta en el procesamiento de recibos
• No somos responsables de decisiones fiscales basadas en el servicio
• Nuestra responsabilidad esta limitada al importe pagado por el servicio`,
      },
      {
        title: '7. Cancelacion',
        content: `Puedes cancelar en cualquier momento:
• Envia "CANCELAR" por WhatsApp
• Accede a tu cuenta en el portal
• El acceso continua hasta el final del periodo pagado
• Tus datos seran eliminados segun nuestra Politica de Privacidad`,
      },
      {
        title: '8. Cambios en los Terminos',
        content: `Podemos modificar estos terminos en cualquier momento. Te notificaremos via:
• Mensaje en WhatsApp
• Email (si esta registrado)
• Aviso en el portal

El uso continuado tras los cambios constituye aceptacion.`,
      },
      {
        title: '9. Contacto',
        content: `Para dudas sobre los Terminos:
• Email: soporte@keepnota.com
• WhatsApp: Envia "AYUDA" a nuestro numero`,
      },
    ],
  },
};
